export default __webpack_public_path__ + "static/media/garden_road.37a62243.jpg";